import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type InsuranceModuleSpecsFragment } from '../../../../api/fragments/InsuranceModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import InsuranceModuleUpdateForm from './InsuranceModuleUpdateForm';

export type InsuranceModuleUpdateDrawerProps = {
    module: InsuranceModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const InsuranceModuleUpdateDrawer = ({ module, onClose, visible }: InsuranceModuleUpdateDrawerProps) => {
    const { t } = useTranslation('insuranceModuleDetails');

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('insuranceModuleDetails:updateDrawer.cancelButton')}</Button>
                    <Button form="updateInsuranceModule" htmlType="submit" type="primary">
                        {t('insuranceModuleDetails:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('insuranceModuleDetails:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <InsuranceModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default InsuranceModuleUpdateDrawer;

export const useUpdateInsuranceModuleDrawer = (module: InsuranceModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <InsuranceModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
